import { FilterArrayType, FilterCombineType } from 'common/components/Filters';
import { ApprovalsOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: ApprovalsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'approvalType',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_DESC',
      ],
    },
  ],
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'priorityNumber',
    {
      [OrderDirection.ASC]: ['PRIORITY_NUMBER_ASC'],
      [OrderDirection.DESC]: ['PRIORITY_NUMBER_DESC'],
    },
  ],
  [
    'isAddApproversEligible',
    {
      [OrderDirection.ASC]: ['IS_ADD_APPROVERS_ELIGIBLE_ASC'],
      [OrderDirection.DESC]: ['IS_ADD_APPROVERS_ELIGIBLE_DESC'],
    },
  ],
  [
    'phaseName',
    {
      [OrderDirection.ASC]: ['APPROVAL_PHASE_BY_ID__PHASE_NAME_ASC'],
      [OrderDirection.DESC]: ['APPROVAL_PHASE_BY_ID__PHASE_NAME_DESC'],
    },
  ],
  [
    'status',
    {
      [OrderDirection.ASC]: ['STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_ASC'],
      [OrderDirection.DESC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_DESC',
      ],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: ApprovalsOrderBy[] | undefined = [
    'APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC',
    'PRIORITY_NUMBER_ASC',
    'PRIMARY_KEY_DESC',
    'REVISION_NUMBER_DESC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};

export const toPaymentFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case '_statusTypeId':
      case 'approvalTypeId':
      case 'approvalPhaseTypeId':
      case '_searchApprovalPhaseTypeId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };
      case 'isNewApprovalSelectable':
        return {
          [filter.filterKey]: {
            equalTo: filter.value === 'yes' ? true : false,
          },
        };
      default:
        return undefined;
    }
  });

export const DEFAULT_FILTER = {
  combineType: FilterCombineType.AND,
  filterKey: 'isNewApprovalSelectable',
  label: 'Yes',
  value: 'yes',
};
